import { render, staticRenderFns } from "./Tageskalender.vue?vue&type=template&id=47ba2336&"
import script from "./Tageskalender.vue?vue&type=script&lang=js&"
export * from "./Tageskalender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports